import React from 'react';
import { MoonshotBilling } from './MoonshotBilling';
import { MoonshotEmailVerification } from './MoonshotEmailVerification';
import { MoonshotSubmitFunction } from './types';
import { useMoonshotBillingQuery } from '@trello/graphql/generated';
import styles from './MoonshotPayment.less';

interface MoonshotPaymentProps {
  onSubmit: MoonshotSubmitFunction;
}

export const MoonshotPayment: React.FC<MoonshotPaymentProps> = ({
  onSubmit,
}) => {
  const { data } = useMoonshotBillingQuery();
  const isConfirmed = data?.member?.confirmed;
  const memberEmail = data?.member?.email ?? '';
  const primaryLogin = data?.member?.logins?.find((login) => login.primary);
  const primaryEmailLoginId = primaryLogin?.id ?? '';

  return (
    <div className={styles.wrapper}>
      <MoonshotBilling
        onFailure={() => {}}
        onSkip={onSubmit}
        onSuccess={onSubmit}
      />
      {isConfirmed === false && (
        <MoonshotEmailVerification
          email={memberEmail}
          loginId={primaryEmailLoginId}
        />
      )}
    </div>
  );
};
